import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class ZoneService extends ApiService {
  constructor(private http: Http) {
    super('api/zones/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/zone.service.ts